import { COMPANY_TYPE } from '@constants/app';
import { useStore } from '../MobxProvider';
import LoggerUtil from '../../helpers/LoggerUtil';

const useUserAccess = () => {
  const store = useStore();

  const storeItems = store.domain.userAccess.get();
  // TODO: Remove hack for companyType
  return {
    ...storeItems,
    companyType: storeItems?.company?.companyType,
    isSA: () =>
      storeItems?.company?.companyType === COMPANY_TYPE.SERVICE_ADMINISTRATOR,
    isSP: () =>
      storeItems?.company?.companyType === COMPANY_TYPE.SERVICE_PROVIDER,
    isAdmin: () => storeItems?.company?.companyType === COMPANY_TYPE.ADMIN,
    isSPReadonly: () =>
      storeItems?.company?.companyType === COMPANY_TYPE.SERVICE_PROVIDER &&
      storeItems?.role?.roleIdentifier === 'READONLY',
    isSAReadonly: () =>
      storeItems?.company?.companyType === COMPANY_TYPE.SERVICE_ADMINISTRATOR &&
      storeItems?.role?.roleIdentifier === 'READONLY',
    isSASupervisor: () =>
      storeItems?.company?.companyType === COMPANY_TYPE.SERVICE_ADMINISTRATOR &&
      storeItems?.role?.roleIdentifier === 'SUPERVISOR',
    isAdminImplementationManager: () =>
      storeItems?.company?.companyType === COMPANY_TYPE.ADMIN &&
      storeItems?.role?.roleIdentifier === 'IMPLEMENTATION_MANAGER',
    isUserReadonly: () => storeItems?.role?.roleIdentifier === 'READONLY',
    isSSO: () => storeItems?.isSsoUser || false,
  };
};

const hasPermission = (permissionName, permissions) => {
  try {
    return permissions[permissionName];
  } catch {
    LoggerUtil.log('Permission Error', { permissions, permissionName });
    return false;
  }
};

export { useUserAccess, hasPermission };
